// extracted by mini-css-extract-plugin
export default {"container":"NosotrosSt_container__C9hbN","contentImg":"NosotrosSt_contentImg__A2cvm","content":"NosotrosSt_content__InAXx"};